module.exports = __webpack_public_path__ + "img/missionaries3_2019_7-7-2021.3aa806d3.jpg";